import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  ElementRef,
  OnInit,
  Attribute
} from '@angular/core';
import { LoginService } from '../api/auth/login.service';

@Directive({
  selector: '[hasPermissions]'
})
export class HasPermissionsDirective implements OnInit {
  private currentUser: any;
  private userPermissions: any;
  private permissions = [];
  private logicalOp = 'AND';
  private isHidden = true;

  constructor(
    private element: ElementRef,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: LoginService
  ) {}

  ngOnInit() {
    this.currentUser = this.authService.getUser();
    this.userPermissions = this.authService.getUserPermissions();
    this.updateView();
  }

  @Input()
  set hasPermissions(val: any) {
    this.permissions = val;
    this.updateView();
  }

  // @Input()
  // set hasPermissionOp(permop:any) {
  //   this.logicalOp = permop;
  //   this.updateView();
  // }

  private updateView() {
    if (this.checkPermission()) {
      if (this.isHidden) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.isHidden = false;
      }
    } else {
      this.isHidden = true;
      this.viewContainer.clear();
    }
  }

  private checkPermission() {
    let hasPermission = false;
    if (this.currentUser && this.userPermissions) {
      for (const checkPermission of this.permissions) {
        const permissionFound = this.userPermissions.some((permission: any) => {
          return (
            permission.name.toUpperCase() ===
            (checkPermission as any).toUpperCase()
          );
        });

        if (permissionFound) {
          hasPermission = true;
          // if (this.logicalOp === 'OR') {
          //   break;
          // }
        } else {
          hasPermission = false;
          // if (this.logicalOp === 'AND') {
          //   break;
          // }
        }
      }
    }

    return hasPermission;
  }
}
